import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const ConsultaPerfis = Loadable({
  loader: () => import('../views/GestaoAcessos/ConsultaPerfis'),
  loading: RouteLoading,
});

const PerfilFuncionalidade = Loadable({
  loader: () => import('../views/GestaoAcessos/PerfilFuncionalidade'),
  loading: RouteLoading,
});
const CadastroUsuario = Loadable({
  loader: () => import('../views/GestaoAcessos/CadastroUsuario'),
  loading: RouteLoading,
});
const CadastroPerfis = Loadable({
  loader: () => import('../views/GestaoAcessos/PerfilFuncionalidade'),
  loading: RouteLoading,
});
const ConsultaUsuarios = Loadable({
  loader: () => import('../views/GestaoAcessos/ConsultaUsuarios'),
  loading: RouteLoading,
});

const RelatorioUsuarios = Loadable({
  loader: () => import('../views/GestaoAcessos/RelatorioUsuarios'),
  loading: RouteLoading,
});

const GestaoEmMassa = Loadable({
  loader: () => import('../views/GestaoAcessos/GestaoEmMassa'),
  loading: RouteLoading,
});

const UsuarioSerpro = Loadable({
  loader: () => import('../views/GestaoAcessos/UsuarioSerpro'),
  loading: RouteLoading,
});

const RouteGestaoAcessos = [
  {
    path: '/gestao-acessos/gestao-perfil-funcionalidades/consulta-perfis',
    name: 'Consulta de Perfis',
    component: ConsultaPerfis,
  },
  {
    path: '/gestao-acessos/cadastro',
    name: 'Cadastro de Usuário',
    component: CadastroUsuario,
  },
  {
    path: '/gestao-acessos/consulta',
    name: 'Consulta de Usuários',
    component: ConsultaUsuarios,
  },
  {
    path: '/gestao-acessos/gestao-perfil-funcionalidades/perfil-funcionalidade/:idPerfil',
    name: 'Associação de Perfil e Funcionalidade',
    component: PerfilFuncionalidade,
  },
  {
    path: '/gestao-acessos/certificado-digital',
    exact: true,
    name: 'Certificado Digital',
    component: UsuarioSerpro,
  },
  {
    path: '/gestao-acessos/relatorio',
    name: 'Relatório',
    component: RelatorioUsuarios,
  },
  {
    path: '/gestao-acessos/gestao-massa',
    name: 'Gestão em Massa',
    component: GestaoEmMassa,
  },
  {
    path: '/gestao-acessos/editar/:idUsuario',
    name: 'Editar Usuário',
    component: CadastroUsuario,
  },
  {
    path: '/gestao-acessos/perfil/:acao',
    name: 'Cadastro Perfil',
    component: CadastroPerfis,
  },
];

export { RouteGestaoAcessos };
